import * as z from "zod";

/**
 * Null once the domain is removed. A domain that a support (helpdesk) email
 * sender sends through stays, and the response names those senders.
 */
export const deleteCustomDomain = {
  name: "deleteCustomDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z
    .object({ blockedBySupportSenderEmails: z.array(z.string()) })
    .nullable(),
};
